import { render, staticRenderFns } from "./CommonDeliveryStatusSelect.vue?vue&type=template&id=5d971bde&lang=pug&"
import script from "./CommonDeliveryStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./CommonDeliveryStatusSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDeliveryStatusSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports